interface PersistConfig {
  key: string;
  blacklist: string[];
}
const rehydrationState = (persistConfig: PersistConfig) => {
  try {
    const keyPersist = persistConfig.key || 'persist';
    const serializedState = localStorage.getItem(keyPersist);
    if (!serializedState) {
      return;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.error('Rehydration State Error: ', error);
    return;
  }
};
export default rehydrationState;
